<section
  [ngStyle]="{ background: authService.currentUserValue.empresaCorPadrao }"
  id="header-user"
>
  <div>
    <h2>Olá, {{ currentUser?.primeiroNome }}</h2>
    <span>{{ currentUser?.email }}</span>
  </div>

  <!-- <ul class="navbar-nav nav align-items-center ml-auto">

    <li id="dropdown-grouped" class="nav-item b-nav-dropdown dropdown dropdown-language" variant="link"><a
        id="dropdown-grouped__BV_toggle_" role="button" aria-haspopup="true" aria-expanded="false"
        href="#dropdown-grouped" target="_self" class="nav-link dropdown-toggle"><img alt="en" width="22" height="14"
          class=""><span class="ml-50 text-body">English</span></a>
      <ul tabindex="-1" aria-labelledby="dropdown-grouped__BV_toggle_" class="dropdown-menu dropdown-menu-right">
        <li role="presentation"><a role="menuitem" href="#" target="_self" class="dropdown-item"><img alt="en"
              width="22" height="14" class=""><span class="ml-50">English</span></a></li>
        <li role="presentation"><a role="menuitem" href="#" target="_self" class="dropdown-item"><img alt="fr"
              width="22" height="14" class=""><span class="ml-50">French</span></a></li>
        <li role="presentation"><a role="menuitem" href="#" target="_self" class="dropdown-item"><img alt="de"
              width="22" height="14" class=""><span class="ml-50">German</span></a></li>
        <li role="presentation"><a role="menuitem" href="#" target="_self" class="dropdown-item"><img alt="pt"
              width="22" height="14" class=""><span class="ml-50">Portuguese</span></a></li>
      </ul>
    </li>
  </ul> -->

  <!-- <div class="dropdown">
    <div class="buttonPrincipal" dropdown-toggle data-toggle="dropdown" >
      <div><img [src]="imagemEscolha">{{paisEscolha}}</div>
      <div><img class="down" src="assets/images/icons/chevron-down.svg"></div>
    </div>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <button class="dropdown-item" href="#"  escolha (click)="passValue($event,'escolha')"><img src="assets/images/icons/brasil.svg">Português</button>
      <button class="dropdown-item" href="#"  escolha1  (click)="passValue($event,'escolha1')"><img src="assets/images/icons/estados-unidos-da-america 1.svg">Inglês</button>
      <button class="dropdown-item" href="#" escolha2  (click)="passValue($event,'escolha2')"><img src="assets/images/icons/espanha 1.svg">Espanhol</button>
    </div>
  </div> -->
</section>
